/**
===================================================
Module: frontend.src.index.tsx
Description: Main entry point for the Redaction frontend React application
Owner: Kawada Technosystem Co Ltd
All Rights Reserved
This script is proprietary and confidential.
Unauthorized copying, distribution, or modification of this
file, via any medium, is strictly prohibited.
===================================================
*/

import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./i18n/config"; // Initialize i18n

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);

root.render(
    <App />
);
